module.exports = __webpack_public_path__ + "media/images/category/feature/coj_d/logo-coj-ja-02436639b24e74fd3ddc4c33c8ad3fbe.svg";